import { Directive, Input, OnChanges, OnInit, input, output } from "@angular/core";

@Directive({
    "selector": "[columnToggler]"
})
export class ColumnTogglerDirective implements OnInit {
    // TODO: Skipped for migration because:
    //  Your application code writes to the input. This prevents migration.
    @Input() ngModel: any[];
    readonly options = input<any[]>(undefined);
    readonly id = input<string>(undefined);

    readonly ngModelChange = output<any[]>();

    constructor () {
    }

    ngOnInit (): void {
        //Check if there are saved column preferences in localStorage
        let preferences = localStorage.getItem(this.id());

        if (preferences) {
            //Set the "selected columns" to the same as the preferences saved in localStorage
            this.ngModel = this.options().filter((col) => preferences.includes(col.header));
            this.ngModelChange.emit(this.ngModel);
        }
    }

    ngOnChanges (obj: any): void {
        //Only update ngModel & localStorage if it's not the first change (the first change happens when it loads any previously saved column preferences)
        if (obj.ngModel && !obj.ngModel.firstChange) {
            //Sort the columns in default order
            this.ngModel = this.options().filter((c) => this.ngModel.indexOf(c) > -1);

            //Save selected column preferences in localStorage
            localStorage.setItem(this.id(), JSON.stringify(this.ngModel.map((c) => c.header)));
        }
    }
}
